import React from 'react';
import { NumberInput } from 'react-admin';
import Heading from 'components/Heading';
import MoneyInput from 'components/MoneyInput';
import { formatCents, getInherited } from 'utils/rateSettings/SharedRateSettingsForm.utils';
import { Stack } from '@mui/material';

type W2BurdensInputsProps = {
  settingsField: string;
  inheritedSettings: any;
};

export const W2BurdensInputs = ({ settingsField, inheritedSettings }: W2BurdensInputsProps) => {
  return (
    <>
      <Heading>W2 Burdens</Heading>
      <Stack paddingLeft={2} width={'100%'} alignItems="flex-start">
        <Heading>W2 Global Burdens</Heading>
        <NumberInput
          label="Social security burden multiplier"
          source={`${settingsField}.w2.social_security_burden_multiplier`}
          helperText={getInherited(inheritedSettings, 'w2.social_security_burden_multiplier')}
        />
        <NumberInput
          label="Medicare burden multiplier"
          source={`${settingsField}.w2.medicare_burden_multiplier`}
          helperText={getInherited(inheritedSettings, 'w2.medicare_burden_multiplier')}
        />
        <MoneyInput
          label="Federal unemployment max burden"
          source={`${settingsField}.w2.federal_unemployment_max_burden_cents`}
          helperText={formatCents(inheritedSettings?.w2.federal_unemployment_max_burden_cents)}
        />
        <NumberInput
          label="Federal unemployment percent burden multiplier"
          source={`${settingsField}.w2.federal_unemployment_percent_burden_multiplier`}
          helperText={getInherited(
            inheritedSettings,
            'w2.federal_unemployment_percent_burden_multiplier',
          )}
        />
        <MoneyInput
          label="State unemployment max burden"
          source={`${settingsField}.w2.state_unemployment_max_burden_cents`}
          helperText={formatCents(inheritedSettings?.w2.state_unemployment_max_burden_cents)}
        />
        <NumberInput
          label="Unemployment percent burden multiplier"
          source={`${settingsField}.w2.state_unemployment_percent_burden_multiplier`}
          helperText={getInherited(
            inheritedSettings,
            'w2.state_unemployment_percent_burden_multiplier',
          )}
        />
        <Heading>W2 Assignment Burdens</Heading>
        <NumberInput
          label="Billable Orientation Burden Hours"
          source={`${settingsField}.w2.billable_orientation_hours`}
          helperText={getInherited(inheritedSettings, 'w2.billable_orientation_hours')}
        />
        <NumberInput
          label="Non Billable Orientation Burden Hours"
          source={`${settingsField}.w2.non_billable_orientation_burden_hours`}
          helperText={getInherited(inheritedSettings, 'w2.non_billable_orientation_burden_hours')}
        />
        <MoneyInput
          label="Compliance Burden"
          source={`${settingsField}.w2.compliance_burden_cents`}
          helperText={formatCents(inheritedSettings?.w2.compliance_burden_cents)}
        />
        <MoneyInput
          label="ADP fee"
          source={`${settingsField}.w2.adp_fee_burden_cents`}
          helperText={formatCents(inheritedSettings?.w2.adp_fee_burden_cents)}
        />
        <MoneyInput
          label="Medical (Per Week)"
          source={`${settingsField}.w2.medical_burden_cents`}
          helperText={formatCents(inheritedSettings?.w2.medical_burden_cents)}
        />
      </Stack>
    </>
  );
};
